module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-3_GA-341d915c03e9134b78afae0b9fbaef49.svg";